import Plugin from 'src/plugin-system/plugin.class';

export default class ScreensaverPlugin extends Plugin {

    init() {

        var that = this;

        this.idleTime = 0;

        setInterval(function() {
            that.idleTime = that.idleTime + 1;
            if (that.idleTime > 10) { // 10 * 60 secs
                that._showScreensaver();
            }
        }, 60000); // 60 secs

        $('body').on('mouseover keypress touchstart', () => {
            this.idleTime = 0;
            this._hideScreensaver();
        });

    }

    _showScreensaver() {
        $('.screensaver').addClass('is--active');
    }

    _hideScreensaver() {
        $('.screensaver').removeClass('is--active');
    }

}